import React from "react";
import Image from "theme/components/atoms/Image";
import { ProductPrice } from "theme/components/atoms/Typography/Price";
import AutocompleteItem from "theme/components/organisms/Autocomplete/AutocompleteItem/AutocompleteItem";
import { useShop } from "web/core/shop/ShopContext";

const ProductItem = ({ selected, result }) => {
  const shop = useShop();

  return (
    <AutocompleteItem
      image={
        <Image
          src={result.imageUrl}
          alt={result.name}
          format="thumbnail"
          appearance="full"
        />
      }
      name={
        <a key={result.sku} href={shop.baseUrl + result.path}>
          {result.name} {result.geographical_origin}
        </a>
      }
      addon={<ProductPrice prices={result.prices} />}
    />
  );
};

export default ProductItem;
